import { configureStore } from '@reduxjs/toolkit';
import { fetchDiabetesDevices } from '~/store/modules/deviceSelection';
import combinedReducers from './combinedReducers.js';
import { logger } from './storeTracker';

const store = configureStore({
  reducer: combinedReducers,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(logger),
});

store.dispatch(fetchDiabetesDevices());

store.subscribe(() => {
  const { countries, accountInformation } = store.getState();
  window.countriesWithApiUrls = {
    countriesList: countries.allCountries,
    countrySelected: accountInformation.countryOfResidence,
  };
});

export default store;
